module.exports = __webpack_public_path__ + "f04c5ed71ec894fad013a85f221e03cc.pdf";